import { Text } from "@assetwatch/ui";
import { BreakdownScoreRow } from "./BreakdownScoreRow";
import type { BreakdownRow, FacilityStatus } from "./types";
import { overallScoreClassName } from "./utils";

export function ScoreBreakdownTab({
  rows,
  overallScore,
  status,
}: {
  rows: BreakdownRow[];
  overallScore: number;
  status: FacilityStatus;
}) {
  return (
    <div className="flex flex-col">
      <div className="flex items-start justify-end gap-(--spacing-16) pb-(--spacing-24)">
        <div className="text-right">
          <div
            className={`font-(family-name:--font-family-title) text-(length:--font-size-display-sm) font-(number:--font-weight-bold) leading-none tabular-nums ${overallScoreClassName(
              status,
            )}`}
          >
            {overallScore}
          </div>
          <Text as="div" size="sm" tone="subtle">
            /100
          </Text>
        </div>
      </div>

      <div className="flex flex-col gap-(--spacing-10)">
        {rows.map((row) => (
          <BreakdownScoreRow key={row.id} row={row} />
        ))}
      </div>
    </div>
  );
}
